import Vue from 'vue'
import VueRouter from 'vue-router'
import reportMixin from '@/mixin/reportMixin.js'

// 全局混入reportMixin，使所有组件都具有页面浏览上报功能
Vue.mixin(reportMixin)
Vue.use(VueRouter)
/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 开始 */
const originalPush = VueRouter.prototype.push
// 修改 原型对象中的push方法
VueRouter.prototype.push = function push(location) {
	return originalPush.call(this, location).catch((err) => err)
}

/* 解决访问重复路由报错问题：NavigationDuplicated: Avoided redundant navigation to current location: "/xxx" 结束 */

let routes = [
	{
		path: '/',
		name: 'home',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
	},
	// {
	// 	path: '/categories',
	// 	name: 'categories',
	// 	component: () => import(/* webpackChunkName: "categories" */ '../pages/categories.vue'),
	// },
	{
		path: '/rank',
		name: 'rankings',
		component: () => import(/* webpackChunkName: "rankings" */ '../pages/rankings.vue'),
	},
	{
		path: '/about-us',
		name: 'about-us',
		component: () => import(/* webpackChunkName: "about-us" */ '../pages/about-us.vue'),
	},
	{
		path: '/privacy-policy',
		name: 'privacy-policy',
		component: () => import(/* webpackChunkName: "privacy-policy" */ '../pages/privacy-policy.vue'),
	},
	{
		path: '/terms-of-service',
		name: 'terms-of-service',
		component: () => import(/* webpackChunkName: "terms-of-service" */ '../pages/terms-of-service.vue'),
	},
	{
		path: '/disclaimer',
		name: 'disclaimer',
		component: () => import('../pages/disclaimer.vue'),
	},
	{
		path: '/list',
		name: 'list',
		component: () => import(/* webpackChunkName: "categories" */ '../pages/categories.vue'),
	},
	{
		path: '/:categoriType',
		name: 'categories',
		component: () => import(/* webpackChunkName: "categories" */ '../pages/categories.vue'),
		props: true,
	},

	{
		path: '/chapter/:novelId/:summaryId/:chapterNum',
		name: 'chapter',
		component: () => import(/* webpackChunkName: "chapter" */ '../pages/chapter.vue'),
		props: true,
	},
	{
		path: '/:categories/:novelId/:id',
		name: 'detail',
		component: () => import(/* webpackChunkName: "detail" */ '../pages/detail.vue'),
		props: true,
	},

	{
		path: '/:channel(channel[1-9]\\d?)/:categoriType',
		name: 'categoriesChannel',
		component: () => import(/* webpackChunkName: "categories" */ '../pages/categories.vue'),
		props: true,
	},
	{
		path: '/:channel(channel[1-9]\\d?)',
		name: 'homechannel',
		component: () => import(/* webpackChunkName: "home" */ '../pages/home.vue'),
		props: true,
		beforeEnter: (to, from, next) => {
			console.log(`Accessing /${to.params.channel}`)
			next()
		},
	},

	// 最后放置通配路由
	{
		path: '*',
		redirect: { name: 'home' },
	},
]

export default function createRouter() {
	const router = new VueRouter({
		mode: 'history',
		routes,
		scrollBehavior(to, from, savedPosition) {
			if (savedPosition) {
				return savedPosition
			} else {
				return { x: 0, y: 0 }
			}
		},
	})
	router.beforeEach((to, from, next) => {
		// 检查是否在浏览器环境中
		if (typeof window === 'undefined') {
			return next()
		}

		const currentHost = window.location.hostname
		const redirectMap = {
			'novelforai.com': 'read.novelforai.com',
			'novelwiai.com': 'read.novelwiai.com',
		}

		const isNotHome = to.name !== 'home' && to.name !== 'homechannel'

		if (redirectMap[currentHost] && isNotHome) {
			const targetHost = redirectMap[currentHost]
			const newUrl = `https://${targetHost}${to.fullPath}`
			window.location.href = newUrl
			return next(false)
		}

		return next()
	})
	return router
}
